import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import LayoutWithMap from 'containers/Base/LayoutWithMap';

import useFilters from 'containers/Base/useFilters.js';
import { filters } from 'containers/Pages/Tasks/Trips/filters';

import { tripActions, tripFilterActions, tripPageActions } from '../';
import * as tripSelectors from '../Selectors/tripSelectors';
import useBusinessClient from 'containers/Pages/People/BusinessClients/Layouts/useBusinessClient.js';

const Trips = ({
  columns,
  filtersRequired,
  details,
  loading,
  downloadable,
}) => {
  // useState
  const [tripGridAPI, setTripGridAPI] = useState();
  //---------------------------Selectors---------------------------
  const tripListData = useSelector(state =>
    tripSelectors.getTripListTransformed(state),
  );
  const totalEntries = useSelector(state =>
    tripSelectors.getTotalEntries(state),
  );
  const filterValues = useSelector(state =>
    tripSelectors.getTripFilters(state),
  );
  const forceRefresh = useSelector(state =>
    tripSelectors.getForceRefresh(state),
  );
  const onDownloadClick = () => {
    dispatchPrintTripList({ filters: localFilterValues });
  };
  const onMapSelectedTripId = useSelector(state =>
    tripSelectors.getSelectedRowID(state),
  );
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  const bizClients = useBusinessClient();
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchTripList = useCallback(
    ({ filters, from }) =>
      dispatch(tripActions.fetchGridList({ filters, from })),
    [dispatch],
  );
  const dispatchPrintTripList = useCallback(
    ({ filters }) => dispatch(tripPageActions.printTripList({ filters })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );
  const onUpdate = filters => {
    dispatchTripList({
      filters,
    });
  };
  const fetchTrips = from => {
    dispatchTripList({
      filters: localFilterValues,
      from,
    });
  };
  const gridAPIHandler = gridAPI => {
    setTripGridAPI(gridAPI);
  };

  const tripHighlight = onMapSelectedTripId => {
    if (onMapSelectedTripId != null) {
      const node = tripGridAPI && tripGridAPI.getRowNode(onMapSelectedTripId);
      // Go to the highlighted node
      tripGridAPI && tripGridAPI.ensureNodeVisible(node, { position: 'top' });
      if (node) {
        if (!node.isSelected()) {
          node.setSelected(true);
        }
      }
    }
  };
  tripHighlight(onMapSelectedTripId);

  return (
    <LayoutWithMap
      header="Trips"
      cols={columns}
      data={tripListData}
      totalEntries={totalEntries}
      loading={loading}
      forceRefresh={forceRefresh}
      //details
      DetailComponent={details}
      //creating and editing
      editable={false}
      onDownloadClick={onDownloadClick}
      downloadable={downloadable}
      //filters
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={filters({
        bizClients,
      })}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            tripFilterActions.setFilterKey({ key: true });
            tripFilterActions.setFilters({ filters });
          },
        })
      }
      //end-filters
      onUpdate={onUpdate}
      fetchData={fetchTrips}
      setGridAPI={gridAPIHandler}
    />
  );
};

Trips.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  downloadable: PropTypes.bool,
  services: PropTypes.array,
};

export default Trips;
